module.exports = __webpack_public_path__ + "media/svg/investisseur-1258c8d5.svg";